import { AlignType, BorderType, PaddingType } from 'common/types/styleTypes'
import {
  backgroundColorCss,
  borderCss,
  boxShadowCss,
  FontProps,
  fontCss,
  lineHeightCss,
  mobileBackgroundColorCss,
  mobileBorderCss,
  mobileBoxShadowCss,
  mobileFontCss,
  mobileLineHeightCss,
  mobilePaddingsCss,
  mobilePlaceholderColorCss,
  mobileTextAlignCss,
  paddingsCss,
  placeholderColorCss,
  textAlignCss,
} from 'common/utils/styleUtilsNew'
import styled, { css } from 'styled-components'
import { SelectNewUiInterface } from '../select-new-ui.schema'

export interface SelectUiStylesInterface extends SelectNewUiInterface {}

export const SelectUi = styled.select<SelectUiStylesInterface>`
  font-size: 16px;
  text-indent: 10px;
  padding: 12px 0;
  outline: none;
  border: 1px solid #b0baca;
  background-color: rgba(255, 255, 255, 1);
  width: 100%;

  ${paddingsCss}
  ${boxShadowCss}
  ${borderCss}
  ${backgroundColorCss}
  ${fontCss}
  ${placeholderColorCss}
  ${textAlignCss}
  ${lineHeightCss}
  ${p => p.hasErrors && 'border-color: red;'}

  ${p => p.theme.phone} {
    ${mobilePaddingsCss}
    ${mobileBoxShadowCss}
    ${mobileBorderCss}
    ${mobileBackgroundColorCss}
    ${mobileFontCss}
    ${mobilePlaceholderColorCss}
    ${mobileTextAlignCss}
    ${mobileLineHeightCss}
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobilePaddingsCss}
      ${mobileBoxShadowCss}
      ${mobileBorderCss}
      ${mobileBackgroundColorCss}
      ${mobileFontCss}
      ${mobilePlaceholderColorCss}
      ${mobileTextAlignCss}
      ${mobileLineHeightCss}
    `}

  ${p =>
    p.theme.isEditor &&
    css`
      pointer-events: none;
    `}
`
